var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Events, JourneysSelectors, TrackingActions, useAppDispatch, useAppSelector } from 'conversional-journey';
import { getStyles } from './markdownRenderer.styles';
/**
 * This helper contains renders for the elements we want to override when
 * rendering the markdown.
 *
 * LinkRenderer sets:
 * - target = _blank
 * - color = brandColor
 * - font style = underline
 */
export var LinkRenderer = function (props) {
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var dispatch = useAppDispatch();
    var classes = getStyles(theme);
    var onClick = function () {
        dispatch(TrackingActions.event(__assign(__assign({}, Events.LINK_CLICK), { label: props.href })));
    };
    var coreProps = {};
    coreProps.onClick = onClick;
    coreProps.target = '_blank';
    coreProps.href = props.href;
    coreProps.className = classes.markdownLink;
    return React.createElement('a', coreProps, props.children);
};
export default LinkRenderer;
